'use strict'

export function getAnimationEndpoint(endpoint, cb) {
  const xhr = new XMLHttpRequest()
  xhr.onreadystatechange = () => {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      cb(JSON.parse(xhr.response))
    }
  }
  xhr.addEventListener('error', err => console.error(err))
  xhr.open('GET', endpoint, true)
  xhr.setRequestHeader('Accept', 'application/json')
  xhr.setRequestHeader('Content-Type', 'application/json')
  xhr.send()
}
